import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { getDefaultLandingPageByRole } from '@orderna/admin-panel/src/utils/get-default-landing-page';
import { LocalStorageService } from '../../shared/services/local-storage.service';

export const landingPageGuard: CanActivateFn = () => {
  const router = inject(Router);
  const localStorage = inject(LocalStorageService);
  const role = localStorage.getRole();

  if (!role) {
    return router.parseUrl('/login');
  }

  return router.parseUrl(getDefaultLandingPageByRole(role));
};
